import { Component, EventEmitter, Inject, Input, LOCALE_ID, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ContactPerson, Contributor } from '@planone/shared/util-interfaces';
import { ImageFileTypes, ImageUrlPipe } from '@planone/shared/util-pipelines';

@Component({
  selector: 'planone-contact-person',
  templateUrl: './contact-person.component.html',
  styleUrls: ['./contact-person.component.scss'],
})
export class ContactPersonComponent {
  @Input() contact?: ContactPerson | Contributor = undefined;
  @Input() contactLink: string | undefined = undefined;
  @Input() contactClickable = true;
  @Input() index: number | undefined = undefined;
  @Input() fairId: string | undefined = undefined;
  @Input() exhibitorId: string | undefined = undefined;
  @Input() exhibitorName: string | undefined = undefined;
  @Input() size: string | null | undefined = undefined;
  @Output() trackContactClick = new EventEmitter<{
    element: EventTarget | null;
    linkText: string | undefined;
    linkType: string;
    contactPersonId: string | undefined;
  }>();

  writeEmailText = $localize`:@@uiElements-contactPerson-writeEmail:E-Mail schreiben`;

  imageUrlPipeline: ImageUrlPipe;

  constructor(@Inject(LOCALE_ID) public localeId: string, private sanitizer: DomSanitizer) {
    this.imageUrlPipeline = new ImageUrlPipe(this.sanitizer);
  }

  get avatarStyle() {
    if (!this.contact?.avatar?.resource) {
      return null;
    }

    return `background-image:url("${this.imageUrlPipeline.transform(
      this.contact.avatar.resource,
      this.contact.avatar.provider,
      {
        width: 200,
        height: 200,
        fileType: ImageFileTypes.WEBP,
      }
    )}");`;
  }

  isContributor(item: ContactPerson | Contributor) {
    return 'contributor_role' in item;
  }
}
